import { z } from 'zod';

export const PACK_TYPE_REPACK = 'repack';
export const PACK_TYPE_WAX = 'wax';
export const PACK_TYPE_INSTANT_WAX = 'instant-wax';

export const PACK_TYPES = z.enum([PACK_TYPE_REPACK, PACK_TYPE_WAX, PACK_TYPE_INSTANT_WAX]);
